/*
items = [{ //make a header
	text: gettext('Visibility'),
	header: true
}, { //make a button
	name: 'make_live',
	text: gettext('Set as live'),
	action: function (data) {
		//do stuff here
	},
}, { //make a divider
	divider: true,
}]
*/
const dropdownButtonTempl = require('sma.admin/components/dropdowns/partials/dropdown_button.mustache');
const dropdownHeadingTempl = require('sma.admin/components/dropdowns/partials/dropdown_heading.mustache');

const Dropdown = Backbone.View.extend({
	initialize: function(options) {
		this.noCaret = options.noCaret || false;
		this.type = options.type || 'button';
		this.btnclass = options.btnclass || 'btn-default';
		this.extraClass = options.extraClass || '';
		this.items = options.items;
		this.title = options.title;
		this.textStyleButton = options.textStyleButton || false;
		this.rightAligned = options.rightAligned || false;
		this.href = options.href || '#';
		this.ariaLabel = options.ariaLabel || gettext('Perform action');
		this.addActionData = options.addActionData || function() { return {}; };
		this.render();
	},

	disable: function() {
		this.$el.find('button').attr('disabled', 'true');
	},

	enable: function() {
		this.$el.find('button').removeAttr('disabled');
	},

	render: function () {
		this.$el.empty();

		let templ;
		if (this.type == 'heading') {
			templ = dropdownHeadingTempl;
		} else {
			templ = dropdownButtonTempl;
		}

		this.$el.html(templ({
			title: this.title,
			btnclass: this.btnclass,
			noCaret: this.noCaret,
			items: this.items,
			textStyleButton: this.textStyleButton ? 'text-style-button' : '',
			type: this.type,
			extraClass: this.extraClass,
			extraItemClass: this.extraItemClass,
			rightAligned: this.rightAligned,
			ariaLabelBtn: this.ariaLabel,
			attribute: this.attribute,
		}));

		this.setEvents();
	},

	setEvents: function () {
		this.items.forEach((action) => {
			if (action && action.action !== undefined && action.action !== null) {
				const $el = this.$el.find(`a[name='${action.name}']`);

				$el.click((_e) => {
					this.doAction(action.action.bind(this));
				});
			}
		});
	},

	doAction: function (action) {
		const data = this.addActionData();
		action(data);
	},

	changeTitle: function (newTitle) {
		this.title = newTitle;
		this.render();
	},
});

module.exports = Dropdown;
